import { Button } from "@narmi/design_system";
import { RouteObject, useNavigate } from "react-router-dom";
import { useUserConfiguration } from "../../hooks/useUserConfiguration";
import { TopBarPageContainer } from "../../components/PageContainer";
import FunctionsContainer from "../../components/narmi_functions/FunctionsContainer";

export const FUNCTIONS_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { ListPageContent } = await import("./FunctionList");
      return {
        Component() {
          const { permissions } = useUserConfiguration();
          const navigate = useNavigate();

          const getActionButton = () => {
            if (permissions.includes("backoffice.add_narmifunction")) {
              return (
                <Button as="a" onClick={() => navigate("new")} label="Add function" size="xs" />
              );
            } else {
              return null;
            }
          };

          return (
            <FunctionsContainer>
              <TopBarPageContainer title="Narmi Functions" action={getActionButton()}>
                <ListPageContent />
              </TopBarPageContainer>
            </FunctionsContainer>
          );
        },
      };
    },
  },
  {
    path: "new",
    async lazy() {
      const { UploadPageContent } = await import("./FunctionUpload");
      return {
        Component() {
          const navigate = useNavigate();

          return (
            <FunctionsContainer>
              <TopBarPageContainer
                title="Create a new Narmi Function"
                backIconOnClick={() => navigate("/functions")}
              >
                <UploadPageContent />
              </TopBarPageContainer>
            </FunctionsContainer>
          );
        },
      };
    },
  },
  {
    path: ":functionId",
    async lazy() {
      const { StatusPageContent } = await import("./FunctionStatus");
      return {
        Component() {
          const navigate = useNavigate();
          return (
            <FunctionsContainer>
              <TopBarPageContainer
                title="View Narmi Function"
                backIconOnClick={() => navigate("/functions")}
              >
                <StatusPageContent />
              </TopBarPageContainer>
            </FunctionsContainer>
          );
        },
      };
    },
  },
  {
    path: ":functionId/update",
    async lazy() {
      const { UploadPageContent } = await import("./FunctionUpload");
      return {
        Component() {
          const navigate = useNavigate();
          return (
            <FunctionsContainer>
              <TopBarPageContainer
                title="Update function configuration"
                backIconOnClick={() => navigate("/functions")}
              >
                <UploadPageContent />
              </TopBarPageContainer>
            </FunctionsContainer>
          );
        },
      };
    },
  },
];
